<template>
  <v-app>
    <v-app-bar app color="dark-grey" dark :src="require('@/assets/rlr_logo.jpg')">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(2,8,12,.2), rgba(2,8,12, 1)"></v-img>
      </template>

      <v-app-bar-nav-icon @click="drawer = !drawer" v-if="$vuetify.breakpoint.smAndDown"></v-app-bar-nav-icon>

      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-spacer></v-spacer>
        <v-btn icon :color="$vuetify.theme.dark ? 'white' : 'blue-grey'" @click="changeDarkMode()">
          <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
        <v-btn to="/current-series" text>
          <span>Competitii</span>
        </v-btn>
        <v-btn to="/rlr-rating" text>
          <span>RLR Rating</span>
        </v-btn>
        <v-btn to="/download" text>
          <span>DOWNLOADS</span>
        </v-btn>
        <v-menu v-if="isLoggedIn" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-badge :value="newMessages" color="pink" dot>
                <span>Contul meu</span>
              </v-badge>
              <v-icon right small>mdi-chevron-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item to="/profile">
              <v-list-item-icon><v-icon>mdi-account-cog-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Cont</v-list-item-title>
            </v-list-item>
            <v-list-item :to="`/driver-profile/${userinfo.id}`">
              <v-list-item-icon><v-icon>mdi-account-circle-outline</v-icon></v-list-item-icon>
              <v-list-item-title>Profil</v-list-item-title>
            </v-list-item>
            <v-list-item to="/teams">
              <v-list-item-icon><v-icon>fa-solid fa-people-group</v-icon></v-list-item-icon>
              <v-list-item-title>Cluburi</v-list-item-title>
            </v-list-item>
            <v-list-item to="/messages">
              <v-list-item-icon><v-icon>fa-solid fa-message</v-icon></v-list-item-icon>
              <v-list-item-title>Mesaje</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isAdministrator" @click="openImpersonationDialog">
              <v-list-item-icon><v-icon>mdi-account-switch</v-icon></v-list-item-icon>
              <v-list-item-title>Autentificare ca utilizator</v-list-item-title>
            </v-list-item>
            <v-list-item to="/logout">
              <v-list-item-icon><v-icon>fa-solid fa-right-from-bracket</v-icon></v-list-item-icon>
              <v-list-item-title>Deconectare</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-if="!isLoggedIn" to="/login" text>
          <span>Conectare</span>
        </v-btn>

        <v-btn icon href="https://discord.gg/wDMGsGNErX" target="_blank">
          <v-icon class="social-icon fab fa-discord"></v-icon>
        </v-btn>
        <v-btn icon href="https://www.facebook.com/racingleague.romania" target="_blank">
          <v-icon class="social-icon fab fa-facebook"></v-icon>
        </v-btn>
        <v-btn icon href="https://www.instagram.com/racingleagueromania/" target="_blank">
          <v-icon class="social-icon fab fa-instagram"></v-icon>
        </v-btn>
        <v-btn icon href="https://www.youtube.com/@RacingLeagueRomania" target="_blank">
          <v-icon class="social-icon fab fa-youtube"></v-icon>
        </v-btn>
        <v-btn icon href="https://x.com/SimraceRo" target="_blank">
          <v-icon class="social-icon fab fa-x-twitter"></v-icon>
        </v-btn>

        <v-spacer></v-spacer>
      </template>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary>
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item>
            <v-list-item-avatar>
              <v-icon>mdi-theme-light-dark</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              Dark mode
            </v-list-item-title>
            <v-switch icon :input-value="$vuetify.theme.dark" @change="changeDarkMode()">
              <v-icon class="fab fa-moon-o"></v-icon>
            </v-switch>
          </v-list-item>
        </v-list-item-group>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <router-link to="/current-series" text :class="['text-decoration-none']">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="fa-solid fa-medal"></v-icon>
              </v-list-item-avatar>
              <v-list-item-title>
                Competitii
              </v-list-item-title>
            </v-list-item>
          </router-link>
          <router-link to="/download" text :class="['text-decoration-none']">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-download</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>
                DOWNLOADS
              </v-list-item-title>
            </v-list-item>
          </router-link>
          <router-link to="/rlr-rating" text :class="['text-decoration-none']">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon>mdi-chart-line</v-icon>
              </v-list-item-avatar>
              <v-list-item-title>
                RLR Rating
              </v-list-item-title>
            </v-list-item>
          </router-link>
          <v-list-group v-if="isLoggedIn" no-action>
            <template v-slot:activator>
              <v-list-item-avatar>
                <v-badge :value="newMessages" color="pink" dot overlap>
                  <v-icon class="fa-solid fa-user"></v-icon>
                </v-badge>
              </v-list-item-avatar>
              <v-list-item-title>Contul meu</v-list-item-title>
            </template>
            <v-list-item to="/profile">
              <v-list-item-title>Cont</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-account-cog-outline</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item :to="`/driver-profile/${userinfo.id}`">
              <v-list-item-title>Profil</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-account-circle-outline</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item to="/teams">
              <v-list-item-title>Cluburi</v-list-item-title>
              <v-list-item-icon><v-icon class="fa-solid fa-people-group"></v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item to="/messages">
              <v-list-item-title>Mesaje</v-list-item-title>
              <v-list-item-icon><v-icon class="fa-solid fa-message"></v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item v-if="isAdministrator" @click="openImpersonationDialog">
              <v-list-item-title>Autentificare ca utilizator</v-list-item-title>
              <v-list-item-icon><v-icon>mdi-account-switch</v-icon></v-list-item-icon>
            </v-list-item>
            <v-list-item to="/logout">
              <v-list-item-title>Deconectare</v-list-item-title>
              <v-list-item-icon><v-icon class="fa-solid fa-right-from-bracket"></v-icon></v-list-item-icon>
            </v-list-item>
          </v-list-group>
          <router-link v-if="!isLoggedIn" to="/login" text :class="['text-decoration-none']">
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="fa-solid fa-right-to-bracket"></v-icon>
              </v-list-item-avatar>
              <v-list-item-title>
                Conectare
              </v-list-item-title>
            </v-list-item>
          </router-link>
        </v-list-item-group>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <v-list-item @click="openLink('https://discord.gg/wDMGsGNErX')" class="cursor-pointer">
            <v-list-item-avatar>
              <v-icon class="fab fa-discord"></v-icon>
            </v-list-item-avatar>
            <v-list-item-title>Discord</v-list-item-title>
          </v-list-item>
          <v-list-item @click="openLink('https://www.facebook.com/racingleague.romania')" class="cursor-pointer">
            <v-list-item-avatar>
              <v-icon class="fab fa-facebook"></v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              Facebook
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="openLink('https://www.instagram.com/racingleagueromania/')" class="cursor-pointer">
            <v-list-item-avatar>
              <v-icon class="fab fa-instagram"></v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              Instagram
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="openLink('https://www.youtube.com/@RacingLeagueRomania')" class="cursor-pointer">
            <v-list-item-avatar>
              <v-icon class="fab fa-youtube"></v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              YouTube
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="openLink('https://x.com/SimraceRo')" class="cursor-pointer">
            <v-list-item-avatar>
              <v-icon class="fab fa-x-twitter"></v-icon>
            </v-list-item-avatar>
            <v-list-item-title>
              x.com
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-alert v-if="isImpersonating" type="warning" tile dense class="mb-0" prominent>
        Ești autentificat ca {{ impersonatedUserName }}.
        <v-btn text color="black" :loading="stoppingImpersonation" @click="returnToAdministrator">
          Revino la contul de administrator
        </v-btn>
      </v-alert>
      <router-view :key="$route.path" />
    </v-main>

    <v-dialog v-model="impersonationDialog" max-width="520">
      <v-card>
        <v-card-title>Autentificare ca utilizator</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="impersonationUserId"
            :items="impersonationUsers"
            label="Utilizator"
            clearable
          ></v-autocomplete>
          Vei folosi platforma cu drepturile utilizatorului selectat timp de cel mult o oră.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="impersonationDialog = false">Anulează</v-btn>
          <v-btn color="primary" :disabled="!impersonationUserId" :loading="startingImpersonation" @click="startImpersonation">
            Continuă
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar :timeout="snackbar.timeout" :value="snackbar.value" :color="snackbar.color" app>
      {{ snackbar.content }}
      <template v-if="snackbar.action.text" v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="closeSnackbar()">
          {{ snackbar.action.text }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';


export default {
  name: 'App',

  components: {},

  data: () => ({
    group: "actions",
    drawer: false,
    messageGetterInterval: null,
    newMessages: 0,
    lastMessagesChecked: 0,
    impersonationDialog: false,
    impersonationUserId: null,
    startingImpersonation: false,
    stoppingImpersonation: false
  }),
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'userinfo']),
    ...mapGetters('user', ['userRoles', 'users']),
    ...mapState('app', ['snackbar']),
    ...mapState('messages', ['messages']),
    isAdministrator() {
      return !this.isImpersonating && this.userRoles.some(role => role && role.name === 'Administrator')
    },
    isImpersonating() {
      return this.userinfo.impersonated === true
    },
    impersonatedUserName() {
      return this.userinfo.impersonatedUserName || this.userinfo.username
    },
    impersonationUsers() {
      const administratorRole = this.userRoles.find(role => role && role.name === 'Administrator')
      const administratorRoleId = administratorRole && administratorRole._id
      return this.users.filter(user => {
        const isCurrentUser = user.value === this.userinfo.id
        const isAdministrator = administratorRoleId && user.roles
          && user.roles.some(roleId => roleId === administratorRoleId)
        return !isCurrentUser && !isAdministrator
      })
    }
  },
  methods: {
    ...mapActions('messages', ['getMessages']),
    ...mapActions('app', ['showSnackbar', 'closeSnackbar']),
    ...mapActions('user', ['getUserRoles', 'getUsers']),
    ...mapActions('auth', ['impersonate', 'stopImpersonation']),
    async openImpersonationDialog() {
      this.impersonationUserId = null
      await this.getUsers()
      this.impersonationDialog = true
    },
    async startImpersonation() {
      this.startingImpersonation = true
      try {
        await this.impersonate(this.impersonationUserId)
        this.impersonationDialog = false
        window.location.assign('/')
      } finally {
        this.startingImpersonation = false
      }
    },
    async returnToAdministrator() {
      this.stoppingImpersonation = true
      try {
        await this.stopImpersonation()
        window.location.assign('/')
      } finally {
        this.stoppingImpersonation = false
      }
    },
    changeDarkMode() {
      console.log(`Setting dark theme to ${!this.$vuetify.theme.dark}`);
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
    async checkMessages() {
      await this.getMessages()
      if (this.messages) {
        this.newMessages = this.messages.map(message => {
          return !message.viewed
        }).reduce((a, c) => { return a + c }, 0);
        if (this.lastMessagesChecked != this.newMessages) {
          this.showSnackbar({
            timeout: 5000,
            value: true,
            color: 'success',
            content: `Ai ${this.newMessages} ${this.newMessages == 1 ? 'mesaj nou' : 'mesaje noi'}`,
            action: {
              callback: this.$router.push,
              params: '/messages',
              text: 'Vezi mesajele',
              thisVal: this.$router
            }
          })
        }
        this.lastMessagesChecked = this.newMessages
      }
    },
    openLink(url) {
      window.open(url, '_blank');
    }
  },
  async mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme) {
      if (theme === "true") {
        this.$vuetify.theme.dark = true;
      } else {
        this.$vuetify.theme.dark = false;
      }
    } else if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      this.$vuetify.theme.dark = true;
      localStorage.setItem(
        "dark_theme",
        this.$vuetify.theme.dark.toString()
      );
    }

    if (this.isLoggedIn) {
      await this.getUserRoles()
      this.checkMessages()
      this.messageGetterInterval = setInterval(this.checkMessages, 30000)
    }
  },
  destroy() {
    this.messageGetterInterval = null
    delete this.messageGetterInterval
  }
};
</script>

<style scoped>
.social-icon {
  font-size: 18px !important;
  width: 18px;
}
</style>
